import React, { useState } from "react";
import { ObjectListItem } from "./components";
import ScopeModal from "../ScopeModal/ScopeModal"; // <-- import your ScopeModal

const NestedList = (props) => {
  const { objectLists, openScopeModal, ...rest } = props;

  return (
    <>
      {objectLists.reduce(
        (items, objectList, objIndex) =>
          reduceChildObjects({
            items,
            objectList,
            objIndex,
            openScopeModal,
            ...rest,
          }),
        []
      )}
    </>
  );
};

const reduceChildObjects = (props) => {
  const {
    items,
    objectList,
    depth,
    formState,
    setFormState,
    key,
    setObjectId,
    objIndex,
    openScopeModal,
  } = props;
  const style = depth > 0 ? { padding: `${depth * 10}px` } : {};

  console.log('formState in reduceChildObjects', formState);

  if (objectList.children) {
    items.push(
      <div key={objectList.id} style={style}>
        <ObjectListItem
          depth={depth}
          objIndex={objIndex}
          label={objectList.label}
          open={false}
          title={objectList.name}
          objectType={objectList?.object_type?.opt_display}
          setFormState={setFormState}
          formState={formState}
          objectListItem={objectList}
          setObjectId={setObjectId}
          openScopeModal={openScopeModal}
        >
          <NestedList
            depth={depth + 1}
            parentDepth={depth}
            objectLists={objectList.children}
            setFormState={setFormState}
            formState={formState}
            setObjectId={setObjectId}
            openScopeModal={openScopeModal}
          />
        </ObjectListItem>
      </div>
    );
  } else {
    items.push(
      <div key={objectList.id} style={style}>
        <ObjectListItem
          depth={depth}
          label={objectList.label}
          title={objectList.name}
          objectType={objectList?.object_type?.opt_display}
          setFormState={setFormState}
          formState={formState}
          objectListItem={objectList}
          setObjectId={setObjectId}
          openScopeModal={openScopeModal}
        />
      </div>
    );
  }

  return items;
};

const NestedObjects = (props) => {
  const { objectLists, formState, setFormState, ...rest } = props;

  const [objectId, setObjectId] = useState("");
  const [showScopeModal, setShowScopeModal] = useState(false);
  const [scopeObject, setScopeObject] = useState(null);

  const [activeKey, setActiveKey] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
    4: null,
  });

  const toggleAccordion = (key, depth) => {
    setActiveKey((activeKey) => ({
      [depth]: activeKey[depth] === key ? null : key,
    }));
  };

  // Handler to open Add Scope modal
  const openScopeModal = (object) => {
    setObjectId(object.id); // Set the objectId here
    setScopeObject(object);
    setShowScopeModal(true);
  };

  const handleCloseScopeModal = () => {
    setShowScopeModal(false);
    setScopeObject(null);
  };

  return (
    <>
      <NestedList
        depth={0}
        objectLists={objectLists}
        setFormState={setFormState}
        formState={formState}
        setObjectId={setObjectId}
        toggleAccordion={toggleAccordion}
        openScopeModal={openScopeModal}
      />

      {/* ScopeModal called in parent */}
      <ScopeModal
        showScopeModal={showScopeModal}
        handleCloseScopeModal={handleCloseScopeModal}
        scopeObject={scopeObject}
        setFormState={setFormState}
        formState={formState}
        objectId={objectId} // Pass objectId to the modal
      />
    </>
  );
};

export default NestedObjects;
